var exports = {
  "wrapper": "x936d19a0--0ad585--wrapper",
  "quiz_completed": "x936d19a0--0ad585--quiz_completed",
  "container": "x936d19a0--0ad585--container",
};

module.exports = exports;
